var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounExternal3933707(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 216 146",
    enableBackground: "new 0 0 216 146",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.686,17.313c-4.588-4.589-10.115-6.884-16.578-6.884H68.893c-6.463,0-11.99,2.295-16.58,6.884  c-4.589,4.59-6.884,10.117-6.884,16.58v78.214c0,6.463,2.295,11.99,6.884,16.58c4.59,4.59,10.117,6.885,16.58,6.885h78.214  c6.463,0,11.99-2.295,16.578-6.885c4.59-4.59,6.885-10.117,6.885-16.58V33.893C170.57,27.43,168.275,21.902,163.686,17.313z   M149.714,75.607c0,2.281-1.06,3.883-3.177,4.807c-0.706,0.271-1.387,0.407-2.037,0.407c-1.466,0-2.688-0.517-3.666-1.548  l-11.732-11.732l-43.505,43.507c-1.033,1.032-2.254,1.548-3.667,1.548c-1.413,0-2.635-0.516-3.667-1.548l-8.31-8.311  c-1.032-1.031-1.548-2.255-1.548-3.666c0-1.412,0.516-2.634,1.548-3.666l43.507-43.507l-11.732-11.732  c-1.684-1.575-2.064-3.475-1.141-5.703c0.923-2.118,2.526-3.178,4.807-3.178H144.5c1.412,0,2.634,0.517,3.667,1.549  c1.031,1.031,1.547,2.254,1.547,3.666V75.607z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounExternal3933707);
export default __webpack_public_path__ + "static/media/noun_External_3933707.9ea56b4d.svg";
export { ForwardRef as ReactComponent };